const auth = [
  {
    path: '/login',
    component: () => import('@/view/Layouts/AuthContainer/AuthContainer.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/view/pages/shared/auth/Login.vue'),
      },
      {
        path: '/reset_password',
        name: 'Recuperação de senha',
        component: () => import('@/view/pages/shared/auth/ResetPassword/ResetPassword.vue'),
      },
      {
        path: '/linkselect',
        name: 'Vinculo',
        props: true,
        component: () => import('@/view/pages/shared/auth/Linkink.vue'),
      },
      {
        name: 'Validação de Email - Cadastro de Senhas',
        path: '/mail-first-access',
        component: () => import('@/view/pages/shared/onboarding/pages/OTPFirstAccessPage.vue'),
      },
      {
        name: 'Cadastro de Senhas',
        path: '/set-password/',
        component: () => import('@/view/pages/shared/onboarding/pages/SetPassword.vue'),
      },
      {
        name: 'Cadastro de Senhas - Validação',
        path: '/set-signature-password',
        component: () => import('@/view/pages/shared/onboarding/pages/SetSignaturePassword.vue'),
      },
      {
        name: 'Início do Onboarding',
        path: '/register',
        component: () => import('@/view/pages/shared/onboarding/components/OnboardingStart.vue'),
      },
    ],
  },
]

export default auth
